import FormBuilder from './FormBuilder';
import parseRequired from './parseRequired';

export { FormBuilder as default, parseRequired };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/index.js
// module id = 668
// module chunks = 0